// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65bac9b4","396":"371eaab0","453":"4a4d5f6f","455":"c6f1020a"}[chunkId] + ".chunk.js";
};